import React from "react";
import { RelatedSearchTermResponse } from "./ProductDetailPageResult";
type FindRelatedProductsProps = {
  relatedSearchTerms: RelatedSearchTermResponse[];
};
const FindRelatedProducts = ({
  relatedSearchTerms
}: FindRelatedProductsProps) => {
  return <div className="findRelatedProducts" data-sentry-component="FindRelatedProducts" data-sentry-source-file="FindRelatedProducts.tsx">
      <h2 className="header-3 clears">Find Related Products</h2>
      <div className="related__searches">
        {relatedSearchTerms.map((searchTerm: RelatedSearchTermResponse) => <React.Fragment key={searchTerm.id}>
            <a href={`/search/${searchTerm.relatedProductSearchTermEncoded}.html`} className="text-sm font-medium text-gray-900 p-1 inline-block bg-gray-50 border-solid border border-gray-200 shadow-sm rounded overflow-hidden whitespace-nowrap hover:border-gray-500 shadow-xs transition duration-100 ease-in" key={searchTerm.id}>
              {searchTerm.relatedProductSearchTerm}
            </a>{" "}
            &nbsp;{" "}
          </React.Fragment>)}
      </div>
    </div>;
};
export default FindRelatedProducts;